import Collapsible from "app/components/Collapsible/Collapsible";
import { Legs } from "app/types/reportType";
import { useState } from "react";
import ReportHeader from "../ReportHeader/ReportHeader";
import { MultipleCollapsibleHeader } from "./MultipleCollapsibleHeader";

type Props = {
  contentType: string;
  legs: Legs | undefined;
  multiplierName: string | undefined;

  submittedType: string;
};

// Shows a header for each multiple bet
// - Icon
// - Name of multiplier
// - Number of selections is the header for a collapsible
// Collapsible content is the legs of the multiple bet
// Each leg has report header

const MultipleBetHeader: React.FC<Props> = props => {
  const { contentType, legs, multiplierName, submittedType } = props;
  const [collapsibleOpen, setCollapsibleOpen] = useState(false);

  const toggleCollapsible = () => {
    setCollapsibleOpen(!collapsibleOpen);
  };

  // If all legs have the same sportName, use that sportName for the icon,
  // otherwise don't show icon.
  const multipleSportName = legs?.every(
    leg => leg.sportName === legs[0].sportName
  )
    ? legs[0].sportName
    : "";
  const numberOfSelections = legs?.length || 0;

  return (
    <Collapsible
      header={
        <MultipleCollapsibleHeader
          multiplierName={multiplierName}
          multipleSportName={multipleSportName}
          numberOfSelections={numberOfSelections}
          collapsibleOpen={collapsibleOpen}
        />
      }
      content={
        <div>
          {" "}
          {legs &&
            legs.map((leg, index) => {
              return (
                <div className={"report__header__multiples__item"} key={index}>
                  <ReportHeader
                    contentType={contentType}
                    eventName={leg.eventName}
                    betType={submittedType}
                    sportName={leg.sportName}
                    marketName={leg.marketName}
                    runnerName={leg.runnerName}
                    isUSPlayerProp={leg.isUSPlayerProp}
                    placedScore={null}
                  />
                </div>
              );
            })}
        </div>
      }
      isActive={collapsibleOpen}
      onToggle={toggleCollapsible}
      withArrows={false}
    />
  );
};

export default MultipleBetHeader;
